
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cyberscout-coverage",
      function () {
        return require("private-next-pages/cyberscout-coverage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cyberscout-coverage"])
      });
    }
  